import { colors } from '@/theme/colors';
import { SvgIconCommonProps } from './types/svg-icon-common-props';
import { cn } from '@/shadcn-ui/utils';

export function ArrowWithShortTailLeft({
  className,
  fillPrimary = colors.neutral0,
  ...props
}: SvgIconCommonProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('h-[24px] w-[24px]', className)}
      {...props}
    >
      <path
        d="M2.77148 12.3809C2.77148 12.0708 2.90905 11.7607 3.15244 11.5436L10.1048 4.74262C10.38 4.48422 10.6657 4.38086 10.9514 4.38086C11.618 4.38086 12.0942 4.83564 12.0942 5.45579C12.0942 5.77621 11.9673 6.05528 11.7556 6.262L9.38524 8.60825L6.26355 11.3989L8.72916 11.2542H21.5969C22.2847 11.2542 22.7715 11.709 22.7715 12.3809C22.7715 13.0424 22.2847 13.5075 21.5969 13.5075H8.72916L6.25297 13.3628L9.38524 16.1535L11.7556 18.4997C11.9673 18.6961 12.0942 18.9752 12.0942 19.2956C12.0942 19.9157 11.618 20.3809 10.9514 20.3809C10.6657 20.3809 10.38 20.2672 10.126 20.0294L3.15244 13.2181C2.90905 12.9907 2.77148 12.6909 2.77148 12.3809Z"
        fill={fillPrimary}
      />
    </svg>
  );
}
